<template>
    <div v-if="value" class="table-responsive">
        <table class="table table-borderless">
            <tr>
                <th class="fit-column">Supplier</th>
                <td class="fit-column">:</td>
                <th class="text-primary">{{ value.supplier ? value.supplier.name : '-' }}</th>
            </tr>
            <tr v-if="value.created_at">
                <th class="fit-column">Tanggal</th>
                <td class="fit-column">:</td>
                <th class="text-primary">{{ formatDate(value.created_at) }}</th>
            </tr>
            <tr>
                <th class="fit-column">Berat Total</th>
                <td class="fit-column">:</td>
                <th class="text-primary">{{ formatNumber(value.berat_total) }} Kg</th>
            </tr>
            <tr>
                <th class="fit-column">Sub Total</th>
                <td class="fit-column">:</td>
                <th class="text-primary">{{ formatNumber(value.sub_total) }}</th>
            </tr>
            <tr class="text-warning">
                <th class="fit-column">Bonus (+)</th>
                <td class="fit-column">:</td>
                <th>{{ value.bonus_status ? formatNumber(value.bonus) : '-' }}</th>
            </tr>
            <tr class="text-info">
                <th class="fit-column">Pengurang (-)</th>
                <td class="fit-column">:</td>
                <th>{{ value.pengurang_status ? formatNumber(value.pengurang) + '%' : '-' }}</th>
            </tr>
            <tr>
                <th class="fit-column">Berat Akhir</th>
                <td class="fit-column">:</td>
                <th class="text-primary">{{ formatNumber(value.berat_akhir) }} Kg</th>
            </tr>
            <tr class="text-info">
                <th class="fit-column">Pajak (-)</th>
                <td class="fit-column">:</td>
                <th>{{ value.pajak_status ? formatNumber(value.pajak) + '%' : '-' }}</th>
            </tr>
            <tr class="text-info">
                <th class="fit-column">Admin (-)</th>
                <td class="fit-column">:</td>
                <th>{{ value.admin_status ? formatNumber(value.admin) : '-' }}</th>
            </tr>
            <tr class="text-info">
                <th class="fit-column">Potongan (-)</th>
                <td class="fit-column">:</td>
                <th>{{ value.potongan_status ? (value.potongan_notes ? value.potongan_notes : formatNumber(value.potongan)) : '-' }}</th>
            </tr>
            <tr class="text-info" v-if="value.potongan_status && value.potongan_notes">
                <th class="fit-column"></th>
                <td class="fit-column"></td>
                <th>{{ formatNumber(value.potongan) }}</th>
            </tr>
            <tr>
                <th class="fit-column">Total Pembayaran</th>
                <td class="fit-column">:</td>
                <th class="text-primary">{{ formatNumber(value.total) }}</th>
            </tr>
            <tr>
                <th class="fit-column">Metode Pembayaran</th>
                <td class="fit-column">:</td>
                <th class="text-primary">{{ formatValue(value.metode_pembayaran && typeof value.metode_pembayaran === 'object' ? value.metode_pembayaran.name : value.metode_pembayaran) }}</th>
            </tr>
        </table>
    </div>
</template>

<script>
export default {
    name: "nota-supplier-viewer",

    props: {
        value: {
            type: Object,
            default: () => {},
        }
    },

    components: {
    },

    data() {
        return {
        }
    },

    created() {
    },

    mounted() {
    },

    computed: {
    },

    watch: {
    },

    methods: {
    },
}
</script>
<style>
.fit-column {
    width: 0.1%;
    white-space: nowrap;
}

th, td {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
}
</style>
